const FileTypes = {
    excel: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel"
    ],
    csv: ["text/csv"]
};

export default FileTypes;
